exports.VilWrapper = function VilWrapper () {
  this.getInstance = () => {
    return $.getVilInstance();
  };
};



// WEBPACK FOOTER //
// ./src/vil/uScope-extensions/vil-wrapper/VilWrapper.js